<script>
var MAX_LICENSE_PDF_BYTES = 15 * 1024 * 1024;

export default {
  name: "ApplicationDetail",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      loading: true,
      error: "",
      activeTab: "info",
      app: null,
      creators: { composer: [], lyricist: [], arranger: [] },
      registryNote: "",
      registryNoteError: "",
      registryLogs: [],
      registryLogsEnabled: false,
      savingNote: false,
      signatureSize: 100,
      signaturePdfError: "",
      savingSignatureSize: false,
      approve: {
        ipi_name_no: "",
        ipi_base_no: "",
        writer_type: "",
        rightsholder_type: "นักแต่งเพลง",
        error: "",
      },
      approving: false,
      approveProgress: "",
      statusReason: "",
      statusReasonNext: "",
      statusReasonTitle: "ระบุเหตุผล",
      statusReasonError: "",
      savingStatus: false,
      deleting: false,
    };
  },
  computed: {
    canDelete: function () {
      return !!(this.config && this.config.canDelete);
    },
    canReview: function () {
      if (!this.config || typeof this.config.canReview === "undefined") {
        return true;
      }
      return !!this.config.canReview;
    },
    listUrl: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-application-member.php?page=application_list_all";
    },
    status: function () {
      return this.statusInfo(this.app && this.app.status);
    },
    displayName: function () {
      return this.applicantDisplayName(this.app || {});
    },
    nameEn: function () {
      var app = this.app || {};
      return [app.first_name_en || "", app.last_name_en || ""].join(" ").replace(/\s+/g, " ").trim() || "-";
    },
    idCardLabel: function () {
      return this.isPassport ? "เลขพาสปอร์ต" : "เลขบัตรประชาชน";
    },
    idCardIcon: function () {
      return this.isPassport ? "ri-passport-line" : "ri-id-card-line";
    },
    isPassport: function () {
      return String((this.app && this.app.id_document_type) || "").toLowerCase() === "passport";
    },
    idCardValue: function () {
      var app = this.app || {};
      if (this.isPassport) {
        return app.passport_number || app.id_card || "-";
      }
      return app.id_card || "-";
    },
    addressText: function () {
      var app = this.app || {};
      return [app.address_street, app.address_subdistrict, app.address_district, app.address_province, app.address_postal_code].filter(Boolean).join(" ") || "-";
    },
    mailingAddressText: function () {
      var app = this.app || {};
      var mailingSame = String(app.mailing_same_as_id || "1") === "1";
      var mailingAddr = [app.mailing_street, app.mailing_subdistrict, app.mailing_district, app.mailing_province, app.mailing_postal_code].filter(Boolean).join(" ");
      if (mailingAddr === "") {
        mailingAddr = mailingSame ? [app.address_street, app.address_subdistrict, app.address_district, app.address_province, app.address_postal_code].filter(Boolean).join(" ") : "";
      }
      return mailingAddr || (mailingSame ? "ใช้ที่อยู่ตามทะเบียน" : "-");
    },
    roleBadges: function () {
      var app = this.app || {};
      var out = [];
      if (String(app.is_composer) === "1") {
        out.push("Composer");
      }
      if (String(app.is_author) === "1") {
        out.push("Lyricist");
      }
      if (String(app.is_arranger) === "1") {
        out.push("Arranger");
      }
      return out;
    },
    ownerName: function () {
      var app = this.app || {};
      var name = String(app.registry_viewed_by || app.status_changed_by || "").trim();
      return name !== "" ? name : "ทีมทะเบียน";
    },
    statusReasonText: function () {
      return String((this.app && this.app.status_reason) || "").trim();
    },
    statusReasonMeta: function () {
      var app = this.app || {};
      var parts = [];
      if (app.status_reason_at) {
        parts.push(this.toThaiDateTime(app.status_reason_at));
      }
      if (app.status_changed_by) {
        parts.push(String(app.status_changed_by));
      }
      return parts.join(" · ");
    },
    consentMeta: function () {
      var app = this.app || {};
      var parts = [];
      var meta = "";
      if (String(app.consent_personal_data || "") === "1") {
        parts.push("PDPA");
      }
      if (String(app.consent_work_certify || "") === "1") {
        parts.push("รับรองผลงาน");
      }
      if (String(app.consent_company_rules || "") === "1") {
        parts.push("ข้อบังคับ");
      }
      if (parts.length) {
        meta = "ความยินยอม: " + parts.join(" · ");
      }
      if (app.consent_at) {
        meta += (meta !== "" ? " — " : "") + this.toThaiDateTime(app.consent_at);
      }
      if (app.consent_ip) {
        meta += (meta !== "" ? " · IP " : "IP ") + String(app.consent_ip);
      }
      return meta || "-";
    },
    isDocComplete: function () {
      var app = this.app || {};
      return String(app.id_document_path || "").trim() !== "";
    },
    isDuplicate: function () {
      return String((this.app && this.app.status) || "").toLowerCase() === "duplicate";
    },
    hideActionButtons: function () {
      return this.isApproved || this.isRejected || !this.canReview;
    },
    isApproved: function () {
      return this.isApprovedStatus(this.app && this.app.status);
    },
    isRejected: function () {
      return this.isRejectedStatus(this.app && this.app.status);
    },
    hasRegistryTimeline: function () {
      return this.registryLogsEnabled || this.hasRegistryFeature;
    },
    hasRegistryFeature: function () {
      var app = this.app;
      if (!app) {
        return false;
      }
      return Object.prototype.hasOwnProperty.call(app, "registry_viewed_at") || Object.prototype.hasOwnProperty.call(app, "registry_review_note");
    },
    hasRegistryViewedCol: function () {
      return !!(this.app && Object.prototype.hasOwnProperty.call(this.app, "registry_viewed_at"));
    },
    hasRegistryNoteCol: function () {
      return !!(this.app && Object.prototype.hasOwnProperty.call(this.app, "registry_review_note"));
    },
    registryViewedAt: function () {
      return this.hasRegistryViewedCol ? String(this.app.registry_viewed_at || "").trim() : "";
    },
    registryViewedMeta: function () {
      var by = this.app && Object.prototype.hasOwnProperty.call(this.app, "registry_viewed_by") ? String(this.app.registry_viewed_by || "").trim() : "";
      return this.toThaiDateTime(this.registryViewedAt) + (by !== "" ? " · โดย " + by : "");
    },
    creatorBlocks: function () {
      var c = this.creators || {};
      return [
        { label: "Composer", names: Array.isArray(c.composer) ? c.composer : [] },
        { label: "Lyricist", names: Array.isArray(c.lyricist) ? c.lyricist : [] },
        { label: "Arranger", names: Array.isArray(c.arranger) ? c.arranger : [] },
      ];
    },
    signatureData: function () {
      return String((this.app && this.app.signature_data) || "").trim();
    },
    pdfSizePct: function () {
      return this.signaturePdfSizePercent(this.app);
    },
    documentRows: function () {
      var app = this.app;
      var rows;
      var idDoc;
      var nameChangeDoc;
      var bankBookDoc;
      var q;
      if (!app) {
        return [];
      }
      idDoc = String(app.id_document_path || "").trim();
      nameChangeDoc = String(app.name_change_document_path || "").trim();
      bankBookDoc = String(app.bank_book_document_path || "").trim();
      q = "id=" + encodeURIComponent(app.id || "") + "&application_no=" + encodeURIComponent(app.application_no || "");
      rows = [
        {
          name: "ลายเซ็นผู้สมัคร",
          hasFile: !!this.signatureData,
          statusText: this.signatureData ? "มีข้อมูล พร้อมใช้งาน" : "ไม่มีข้อมูล",
          statusCls: this.signatureData ? "bg-success-subtle text-success" : "bg-light text-muted",
          extraBadge: this.signatureData && this.pdfSizePct !== 100 ? "PDF " + this.pdfSizePct + "%" : "",
          action: this.signatureData ? "signature" : "none",
        },
        {
          name: "ใบสมัครสมาชิก",
          hasFile: true,
          statusText: "ข้อมูลจากฐานข้อมูล",
          statusCls: "bg-info-subtle text-primary",
          extraBadge: "",
          action: "download",
          href: this.templateHref("applicationfor_member2.php", q),
          downloadName: this.membershipFilename,
        },
        {
          name: "แบบให้ความยินยอมข้อมูลส่วนบุคคล (PDPA)",
          hasFile: true,
          statusText: "ข้อมูลจากฐานข้อมูล",
          statusCls: "bg-info-subtle text-primary",
          extraBadge: "",
          action: "download",
          href: this.templateHref("pdpa_membar.php", q),
          targetBlank: true,
        },
        {
          name: this.isPassport ? "เอกสารพาสปอร์ต" : "เอกสารบัตรประชาชน",
          hasFile: !!idDoc,
          statusText: idDoc ? "พบไฟล์" : "ไม่พบไฟล์",
          statusCls: idDoc ? "bg-success-subtle text-success" : "bg-light text-muted",
          extraBadge: "",
          action: idDoc ? "download" : "none",
          href: this.publicHref(idDoc),
        },
        {
          name: "หน้าสมุดบัญชีธนาคาร",
          hasFile: !!bankBookDoc,
          statusText: bankBookDoc ? "พบไฟล์" : "ไม่ได้แนบ",
          statusCls: bankBookDoc ? "bg-success-subtle text-success" : "bg-light text-muted",
          extraBadge: "",
          action: bankBookDoc ? "download" : "none",
          href: this.publicHref(bankBookDoc),
        },
      ];
      if (nameChangeDoc || String(app.old_name || "").trim() !== "") {
        rows.push({
          name: "เอกสารยืนยันการเปลี่ยนชื่อ",
          hasFile: !!nameChangeDoc,
          statusText: nameChangeDoc ? "พบไฟล์" : "รอเอกสาร",
          statusCls: nameChangeDoc ? "bg-success-subtle text-success" : "bg-warning-subtle text-warning",
          extraBadge: "",
          action: nameChangeDoc ? "download" : "none",
          href: this.publicHref(nameChangeDoc),
        });
      }
      rows.push({
        name: "สัญญาอนุญาตสิทธิประเภททั่วไป (General License) และประเภทดิจิทัล (Digital License) นักแต่งเพลง",
        hasFile: true,
        statusText: "ข้อมูลจากฐานข้อมูล",
        statusCls: "bg-info-subtle text-primary",
        extraBadge: "",
        action: "download",
        href: this.templateHref("agreement.php", q),
      });
      rows.push({
        name: "รายละเอียดงานดนตรีกรรม",
        hasFile: true,
        statusText: "ข้อมูลจากฐานข้อมูล",
        statusCls: "bg-info-subtle text-primary",
        extraBadge: "",
        action: "dropdown",
        items: [
          { label: "XLSX", href: this.templateHref("musical_works_list_xlsx.php", q) },
          { label: "PDF", href: this.templateHref("musical_works_list.php", q) },
        ],
      });
      return rows;
    },
    membershipFilename: function () {
      var applicantName = this.displayName.replace(/[\\/:*?"<>|]+/g, "_");
      var safeApplicationNo = String((this.app && this.app.application_no) || "").trim().replace(/[\\/:*?"<>|]+/g, "_");
      return "ใบสมัครสมาชิก_" + (safeApplicationNo || "-") + "_" + (applicantName || "-") + ".pdf";
    },
    zipDownloadUrl: function () {
      var api = String((this.config && this.config.downloadDocsZipApi) || "").trim();
      var id = String((this.app && this.app.id) || "").trim();
      var appNo = String((this.app && this.app.application_no) || "").trim();
      if (!api || (id === "" && appNo === "")) {
        return "";
      }
      return id !== "" ? api + "?id=" + encodeURIComponent(id) : api + "?application_no=" + encodeURIComponent(appNo);
    },
  },
  mounted: function () {
    var self = this;
    this.loadDetail();
    this.$nextTick(function () {
      if (self.$refs.signatureModal) {
        self.$refs.signatureModal.addEventListener("hidden.bs.modal", self.onSignatureModalHidden);
      }
    });
  },
  beforeUnmount: function () {
    if (this.$refs.signatureModal) {
      this.$refs.signatureModal.removeEventListener("hidden.bs.modal", this.onSignatureModalHidden);
    }
  },
  methods: {
    txt: function (v) {
      var s = String(v || "").trim();
      return s === "" ? "-" : s;
    },
    publicHref: function (path) {
      var p = String(path || "").trim();
      var b;
      var rel;
      if (!p) {
        return "";
      }
      if (/^https?:\/\//i.test(p) || p.indexOf("data:") === 0) {
        return p;
      }
      b = String((this.config && this.config.basePath) || "").replace(/\/$/, "");
      rel = p.replace(/^\/+/, "");
      return (b ? b + "/" : "") + rel;
    },
    templateHref: function (file, query) {
      return this.publicHref("templatempdf/application_membership/" + file) + "?" + query;
    },
    toThaiDateTime: function (raw) {
      var t = String(raw || "").trim();
      var d;
      if (t === "") {
        return "-";
      }
      d = new Date(t.replace(" ", "T"));
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleString("th-TH", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toThaiDate: function (raw) {
      var t = String(raw || "").trim();
      var d;
      if (t === "") {
        return "-";
      }
      d = new Date(t.replace(" ", "T"));
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleDateString("th-TH", { year: "numeric", month: "2-digit", day: "2-digit" });
    },
    applicantDisplayName: function (app) {
      var fullName = [app.prefix || "", app.first_name || "", app.last_name || ""].join(" ").replace(/\s+/g, " ").trim();
      var englishName;
      var publisher;
      if (fullName !== "") {
        return fullName;
      }
      englishName = [app.first_name_en || "", app.last_name_en || ""].join(" ").replace(/\s+/g, " ").trim();
      if (englishName !== "") {
        return englishName;
      }
      publisher = String(app.publisher || "").trim();
      return publisher !== "" ? publisher : "-";
    },
    statusInfo: function (status) {
      var s = String(status || "").toLowerCase();
      if (["submitted", "pending", "pending_review"].indexOf(s) !== -1) {
        return { cls: "bg-warning-subtle text-warning", icon: "ri-time-line", label: "รอตรวจสอบ", msg: "ใบสมัครนี้อยู่ระหว่างรอการตรวจสอบ" };
      }
      if (["approved", "accepted", "pass", "passed"].indexOf(s) !== -1) {
        return { cls: "bg-success-subtle text-success", icon: "ri-checkbox-circle-line", label: "ผ่านการพิจารณา", msg: "ใบสมัครนี้ได้รับการอนุมัติแล้ว" };
      }
      if (["rejected", "declined", "failed", "not_approved"].indexOf(s) !== -1) {
        return { cls: "bg-danger-subtle text-danger", icon: "ri-close-circle-line", label: "ไม่ผ่านการพิจารณา", msg: "ใบสมัครนี้ไม่ผ่านการพิจารณา" };
      }
      if (s === "duplicate") {
        return { cls: "bg-info-subtle text-info", icon: "ri-file-copy-2-line", label: "ใบสมัครซ้ำ", msg: "พบข้อมูลซ้ำกับใบสมัครอื่น" };
      }
      if (["incomplete", "missing_data"].indexOf(s) !== -1) {
        return { cls: "bg-secondary-subtle text-secondary", icon: "ri-file-warning-line", label: "ข้อมูลไม่ครบ", msg: "ใบสมัครนี้ยังมีข้อมูลหรือเอกสารไม่ครบถ้วน" };
      }
      return { cls: "bg-light text-muted", icon: "ri-information-line", label: "ไม่ระบุสถานะ", msg: "ไม่พบข้อมูลสถานะที่ชัดเจน" };
    },
    isApprovedStatus: function (status) {
      var s = String(status || "").toLowerCase();
      return ["approved", "accepted", "pass", "passed"].indexOf(s) !== -1;
    },
    isRejectedStatus: function (status) {
      var s = String(status || "").toLowerCase();
      return ["rejected", "declined", "failed", "not_approved"].indexOf(s) !== -1;
    },
    signaturePdfSizePercent: function (app) {
      var pct;
      if (!app || !Object.prototype.hasOwnProperty.call(app, "signature_pdf_size_percent")) {
        return 100;
      }
      pct = parseInt(String(app.signature_pdf_size_percent || "100"), 10);
      if (isNaN(pct) || pct < 25) {
        return 25;
      }
      if (pct > 300) {
        return 300;
      }
      return pct;
    },
    showModal: function (refName) {
      var el = this.$refs[refName];
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        window.alert("ไม่พบ Bootstrap Modal");
        return;
      }
      window.bootstrap.Modal.getOrCreateInstance(el).show();
    },
    hideModal: function (refName) {
      var el = this.$refs[refName];
      var inst;
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      inst = window.bootstrap.Modal.getInstance(el);
      if (inst) {
        inst.hide();
      }
    },
    postForm: function (url, payload) {
      return fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        credentials: "same-origin",
        body: payload.toString(),
      }).then(function (res) {
        return res.json();
      });
    },
    parseJsonResponse: function (res) {
      return res.text().then(function (text) {
        var raw = String(text || "").trim();
        if (!raw) {
          throw new Error("เซิร์ฟเวอร์ไม่ส่งข้อมูลกลับมา");
        }
        try {
          return JSON.parse(raw);
        } catch (e) {
          throw new Error("เซิร์ฟเวอร์ตอบกลับไม่ถูกต้อง: " + raw.slice(0, 180));
        }
      });
    },
    blobToBase64: function (blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var result = String(reader.result || "");
          var marker = "base64,";
          var pos = result.indexOf(marker);
          resolve(pos >= 0 ? result.slice(pos + marker.length) : result);
        };
        reader.onerror = function () {
          reject(new Error("read_file_failed"));
        };
        reader.readAsDataURL(blob);
      });
    },
    uploadLicensePdfInChunks: function (file, onProgress) {
      var self = this;
      var chunkSize = 4 * 1024;
      var totalChunks = Math.max(1, Math.ceil(file.size / chunkSize));
      var uploadId = "";
      var index = 0;
      var api = String((this.config && this.config.licenseChunkUploadApi) || "").trim();
      function sendNext() {
        var start;
        var blob;
        if (index >= totalChunks) {
          return Promise.resolve(uploadId);
        }
        start = index * chunkSize;
        blob = file.slice(start, start + chunkSize);
        return self.blobToBase64(blob).then(function (base64) {
          var qs;
          var url;
          if (!base64) {
            throw new Error("ไม่สามารถอ่านชิ้นส่วนไฟล์ได้");
          }
          qs = new URLSearchParams();
          qs.set("upload_id", uploadId || "");
          qs.set("chunk_index", String(index));
          qs.set("total_chunks", String(totalChunks));
          qs.set("file_name", "license.pdf");
          url = api + (api.indexOf("?") >= 0 ? "&" : "?") + qs.toString();
          return fetch(url, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Mct-Upload-Id": uploadId || "",
              "X-Mct-Chunk-Index": String(index),
              "X-Mct-Total-Chunks": String(totalChunks),
              "X-Mct-File-Name": "license.pdf",
              "X-Mct-Chunk-Data": base64,
            },
            credentials: "same-origin",
            body: "",
          });
        })
          .then(self.parseJsonResponse)
          .then(function (json) {
            if (!json || json.success !== true) {
              throw new Error(json && json.message ? json.message : "อัปโหลดไฟล์สัญญาไม่สำเร็จ");
            }
            uploadId = String(json.upload_id || json.temp_token || "");
            if (!uploadId) {
              throw new Error("เซิร์ฟเวอร์ไม่ได้ส่งรหัสการอัปโหลดกลับมา");
            }
            index += 1;
            if (typeof onProgress === "function") {
              onProgress(index, totalChunks);
            }
            return sendNext();
          });
      }
      return sendNext();
    },
    loadDetail: function () {
      var self = this;
      var api = String((this.config && this.config.detailApi) || "").trim();
      var applicationId = Number((this.config && this.config.applicationId) || 0);
      var applicationNo = String((this.config && this.config.applicationNo) || "").trim();
      var url = api;
      this.loading = true;
      this.error = "";
      if (applicationId > 0) {
        url += "?id=" + encodeURIComponent(applicationId);
      } else if (applicationNo !== "") {
        url += "?application_no=" + encodeURIComponent(applicationNo);
      } else {
        this.loading = false;
        this.error = "ไม่พบพารามิเตอร์ id หรือ application_no";
        return;
      }
      fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || json.success !== true || !json.application) {
            throw new Error(json && json.message ? json.message : "ไม่สามารถโหลดข้อมูลได้");
          }
          self.app = json.application;
          self.creators = json.song_creators || { composer: [], lyricist: [], arranger: [] };
          self.registryNote = "";
          self.registryLogs = Array.isArray(json.registry_logs) ? json.registry_logs : [];
          self.registryLogsEnabled = Object.prototype.hasOwnProperty.call(json, "registry_logs") || self.registryLogs.length > 0;
          self.loading = false;
          self.maybeMarkRegistryViewed();
        })
        .catch(function (err) {
          self.loading = false;
          self.error = err && err.message ? err.message : "เกิดข้อผิดพลาดระหว่างโหลดข้อมูล";
        });
    },
    maybeMarkRegistryViewed: function () {
      var self = this;
      var payload;
      var api;
      if (!this.app) {
        return;
      }
      api = String((this.config && this.config.registryTrackingApi) || "").trim();
      if (api === "") {
        return;
      }
      payload = new URLSearchParams();
      payload.set("application_id", String(this.app.id || ""));
      payload.set("application_no", String(this.app.application_no || ""));
      payload.set("mark_viewed", "1");
      this.postForm(api, payload)
        .then(function (json) {
          if (!json || json.success !== true) {
            return;
          }
          if (typeof json.registry_viewed_at === "string" && json.registry_viewed_at !== "") {
            self.app.registry_viewed_at = json.registry_viewed_at;
          }
          if (typeof json.registry_viewed_by === "string") {
            self.app.registry_viewed_by = json.registry_viewed_by;
          }
          if (Array.isArray(json.registry_logs)) {
            self.registryLogs = json.registry_logs;
            self.registryLogsEnabled = true;
          }
        })
        .catch(function () {});
    },
    saveRegistryNote: function () {
      var self = this;
      var payload;
      var api = String((this.config && this.config.registryTrackingApi) || "").trim();
      var note = String(this.registryNote || "").trim();
      this.registryNoteError = "";
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return;
      }
      if (note === "") {
        this.registryNoteError = "กรุณากรอกขั้นตอนที่ต้องการบันทึก";
        return;
      }
      this.savingNote = true;
      payload = new URLSearchParams();
      payload.set("application_id", String(this.app.id || ""));
      payload.set("application_no", String(this.app.application_no || ""));
      payload.set("log_message", note);
      this.postForm(api, payload)
        .then(function (json) {
          if (!json || json.success !== true) {
            self.registryNoteError = json && json.message ? json.message : "ไม่สามารถบันทึกขั้นตอนได้";
            return;
          }
          if (typeof json.registry_review_note === "string") {
            self.app.registry_review_note = json.registry_review_note;
          }
          if (Array.isArray(json.registry_logs)) {
            self.registryLogs = json.registry_logs;
            self.registryLogsEnabled = true;
          }
          self.registryNote = "";
        })
        .catch(function () {
          self.registryNoteError = "เกิดข้อผิดพลาดระหว่างบันทึก";
        })
        .finally(function () {
          self.savingNote = false;
        });
    },
    registryEventLabel: function (type) {
      var t = String(type || "").toLowerCase();
      if (t === "viewed") {
        return "เปิดดู";
      }
      if (t === "status") {
        return "สถานะ";
      }
      return "ขั้นตอน";
    },
    registryEventBadge: function (type) {
      var t = String(type || "").toLowerCase();
      if (t === "viewed") {
        return "bg-info-subtle text-info";
      }
      if (t === "status") {
        return "bg-warning-subtle text-warning";
      }
      return "bg-primary-subtle text-primary";
    },
    registryEventIcon: function (type) {
      var t = String(type || "").toLowerCase();
      if (t === "viewed") {
        return "ri-eye-line";
      }
      if (t === "status") {
        return "ri-flag-line";
      }
      return "ri-chat-1-line";
    },
    openSignatureModal: function () {
      if (!this.signatureData) {
        window.alert("ไม่พบข้อมูลลายเซ็น");
        return;
      }
      this.signaturePdfError = "";
      this.signatureSize = this.pdfSizePct;
      this.showModal("signatureModal");
    },
    resetSignatureSize: function () {
      this.signatureSize = 100;
    },
    saveSignaturePdfSize: function () {
      var self = this;
      var pct = parseInt(String(this.signatureSize || "100"), 10);
      var payload;
      var api = String((this.config && this.config.signaturePdfSizeApi) || "").trim();
      this.signaturePdfError = "";
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return;
      }
      if (isNaN(pct) || pct < 25 || pct > 300) {
        this.signaturePdfError = "ขนาดต้องอยู่ระหว่าง 25% ถึง 300%";
        return;
      }
      this.savingSignatureSize = true;
      payload = new URLSearchParams();
      payload.set("application_id", String(this.app.id || ""));
      payload.set("application_no", String(this.app.application_no || ""));
      payload.set("signature_pdf_size_percent", String(pct));
      this.postForm(api, payload)
        .then(function (json) {
          if (!json || json.success !== true) {
            self.signaturePdfError = json && json.message ? json.message : "ไม่สามารถบันทึกขนาดได้";
            return;
          }
          self.app.signature_pdf_size_percent =
            typeof json.signature_pdf_size_percent !== "undefined" ? json.signature_pdf_size_percent : pct;
          window.alert("บันทึกขนาดลายเซ็นสำหรับ PDF เรียบร้อย (" + pct + "%)");
        })
        .catch(function () {
          self.signaturePdfError = "เกิดข้อผิดพลาดระหว่างบันทึก";
        })
        .finally(function () {
          self.savingSignatureSize = false;
        });
    },
    onDownloadAllDocuments: function () {
      if (!this.zipDownloadUrl) {
        window.alert("ยังไม่พบข้อมูลเอกสารสำหรับดาวน์โหลด");
        return;
      }
      window.location.href = this.zipDownloadUrl;
    },
    openApproveModal: function () {
      if (!this.canReview) {
        return;
      }
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return;
      }
      if (this.isApproved) {
        window.alert("ใบสมัครนี้อนุมัติแล้ว");
        return;
      }
      this.approve = {
        ipi_name_no: "",
        ipi_base_no: "",
        writer_type: "",
        rightsholder_type: "นักแต่งเพลง",
        error: "",
      };
      if (this.$refs.licensePdf) {
        this.$refs.licensePdf.value = "";
      }
      this.showModal("approveModal");
    },
    submitApproveForm: function (ev) {
      var self = this;
      var licenseInput = this.$refs.licensePdf;
      var licenseFile;
      var approveApi = String((this.config && this.config.approveApi) || "").trim();
      ev.preventDefault();
      if (!this.app) {
        return;
      }
      this.approve.error = "";
      if (!licenseInput || !licenseInput.files || licenseInput.files.length === 0) {
        this.approve.error = "กรุณาแนบไฟล์ PDF สัญญาอนุญาตสิทธิ";
        return;
      }
      licenseFile = licenseInput.files[0];
      if (licenseFile.size > MAX_LICENSE_PDF_BYTES) {
        this.approve.error = "ไฟล์ PDF มีขนาดเกิน 15MB กรุณาเลือกไฟล์ที่เล็กลง";
        return;
      }
      if (licenseFile.type && licenseFile.type !== "application/pdf") {
        this.approve.error = "รองรับเฉพาะไฟล์ PDF";
        return;
      }
      this.approving = true;
      this.approveProgress = "กำลังอัปโหลดไฟล์...";
      this.uploadLicensePdfInChunks(licenseFile, function (done, total) {
        self.approveProgress = "กำลังอัปโหลดไฟล์ (" + done + "/" + total + ")...";
      })
        .then(function (tempToken) {
          var payload = new FormData();
          self.approveProgress = "กำลังบันทึก...";
          payload.set("application_id", String(self.app.id || ""));
          payload.set("application_no", String(self.app.application_no || ""));
          payload.set("ipi_name_no", String(self.approve.ipi_name_no || "").trim());
          payload.set("ipi_base_no", String(self.approve.ipi_base_no || "").trim().toUpperCase());
          payload.set("writer_type", String(self.approve.writer_type || "").trim());
          payload.set("rightsholder_type", String(self.approve.rightsholder_type || "").trim());
          payload.set("license_pdf_name", licenseFile.name || "license.pdf");
          payload.set("license_pdf_temp_token", tempToken);
          return fetch(approveApi, {
            method: "POST",
            headers: { Accept: "application/json" },
            credentials: "same-origin",
            body: payload,
          });
        })
        .then(this.parseJsonResponse)
        .then(function (json) {
          var successMsg;
          if (!json || json.success !== true) {
            self.approve.error = json && json.message ? json.message : "ไม่สามารถอนุมัติใบสมัครได้";
            return;
          }
          self.hideModal("approveModal");
          successMsg = "อนุมัติสำเร็จ รหัสสมาชิก: " + (json.member_code || "-");
          if (json.email_sent === true) {
            successMsg += "\n\nส่งอีเมลแจ้งผู้สมัครพร้อมแนบไฟล์สัญญาเรียบร้อย";
          } else {
            successMsg += "\n\nแต่ส่งอีเมลไม่สำเร็จ กรุณาตรวจสอบ log ที่ SyncfileData/application_membership/logs/mail_fail.log";
            if (json.email_error) {
              successMsg += "\nสาเหตุ: " + json.email_error;
            }
          }
          window.alert(successMsg);
          self.loadDetail();
        })
        .catch(function (err) {
          self.approve.error = err && err.message ? String(err.message) : "เกิดข้อผิดพลาดระหว่างบันทึกข้อมูล";
        })
        .finally(function () {
          self.approving = false;
          self.approveProgress = "";
        });
    },
    updateApplicationStatus: function (nextStatus, reason) {
      var api = String((this.config && this.config.updateStatusApi) || "").trim();
      var payload;
      if (!this.canReview) {
        window.alert("ไม่มีสิทธิ์ปรับสถานะใบสมัคร");
        return Promise.resolve(false);
      }
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return Promise.resolve(false);
      }
      payload = new URLSearchParams();
      payload.set("application_id", String(this.app.id || ""));
      payload.set("application_no", String(this.app.application_no || ""));
      payload.set("status", String(nextStatus || "").trim().toLowerCase());
      if (reason) {
        payload.set("reason", String(reason));
      }
      return this.postForm(api, payload)
        .then(function (json) {
          if (!json || json.success !== true) {
            window.alert(json && json.message ? json.message : "ไม่สามารถอัปเดตสถานะได้");
            return false;
          }
          return true;
        })
        .catch(function () {
          window.alert("เกิดข้อผิดพลาดระหว่างอัปเดตสถานะ");
          return false;
        });
    },
    openStatusReasonModal: function (nextStatus, titleText) {
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return;
      }
      if (this.isApproved) {
        window.alert("ใบสมัครนี้อนุมัติแล้ว");
        return;
      }
      if (this.isRejected && nextStatus === "rejected") {
        window.alert("ใบสมัครนี้ไม่ผ่านการพิจารณาแล้ว");
        return;
      }
      this.statusReasonTitle = titleText || "ระบุเหตุผล";
      this.statusReasonNext = String(nextStatus || "");
      this.statusReason = String(this.app.status_reason || "");
      this.statusReasonError = "";
      this.showModal("statusReasonModal");
    },
    submitStatusReasonForm: function (e) {
      var self = this;
      e.preventDefault();
      if (String(this.statusReason || "").trim().length < 5) {
        this.statusReasonError = "กรุณาระบุเหตุผลอย่างน้อย 5 ตัวอักษร";
        return;
      }
      this.savingStatus = true;
      this.updateApplicationStatus(this.statusReasonNext, String(this.statusReason || "").trim()).then(function (ok) {
        self.savingStatus = false;
        if (!ok) {
          return;
        }
        self.hideModal("statusReasonModal");
        window.alert("อัปเดตสถานะเรียบร้อย");
        self.loadDetail();
      });
    },
    onDeleteApplication: function () {
      var self = this;
      var appNo;
      var msg;
      var payload;
      var api = String((this.config && this.config.deleteApi) || "").trim();
      if (!this.app) {
        window.alert("ยังโหลดข้อมูลใบสมัครไม่เสร็จ");
        return;
      }
      appNo = String(this.app.application_no || "").trim();
      msg =
        "ยืนยันการลบใบสมัครนี้ถาวรหรือไม่?\n\n" +
        "ระบบจะลบข้อมูลในฐานข้อมูลที่เกี่ยวข้อง และลบไฟล์เอกสารที่อัปโหลด (ถ้ามี)\n" +
        "เลขที่ใบสมัคร: " +
        (appNo || "-");
      if (!window.confirm(msg)) {
        return;
      }
      this.deleting = true;
      payload = new URLSearchParams();
      payload.set("application_id", String(this.app.id || ""));
      payload.set("application_no", appNo);
      this.postForm(api, payload)
        .then(function (json) {
          if (!json || json.success !== true) {
            window.alert(json && json.message ? json.message : "ไม่สามารถลบข้อมูลได้");
            self.deleting = false;
            return;
          }
          window.alert("ลบข้อมูลเรียบร้อยแล้ว");
          window.location.href = self.listUrl;
        })
        .catch(function () {
          window.alert("เกิดข้อผิดพลาดระหว่างลบข้อมูล");
          self.deleting = false;
        });
    },
    onSignatureModalHidden: function () {
      this.signatureSize = this.pdfSizePct;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0"><i class="ri-file-user-line me-1 align-middle"></i>รายละเอียดใบสมัครสมาชิก</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a :href="listUrl">ใบสมัครออนไลน์</a></li>
              <li class="breadcrumb-item active">View Application Member</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-xl-8">
        <div class="card h-100">
          <div class="card-header border-0 pb-0">
            <div class="d-flex flex-nowrap justify-content-between align-items-center gap-2">
              <ul class="nav nav-tabs nav-tabs-custom mb-0 flex-nowrap app-detail-tab-nav" role="tablist">
                <li class="nav-item">
                  <button type="button" class="nav-link" :class="{ active: activeTab === 'info' }" @click="activeTab = 'info'">
                    <i class="ri-user-3-line align-middle me-1"></i>ข้อมูลใบสมัคร
                  </button>
                </li>
                <li class="nav-item">
                  <button type="button" class="nav-link" :class="{ active: activeTab === 'song' }" @click="activeTab = 'song'">
                    <i class="ri-music-2-line align-middle me-1"></i>ผลงานเพลงและผู้สร้างสรรค์
                  </button>
                </li>
                <li class="nav-item">
                  <button type="button" class="nav-link" :class="{ active: activeTab === 'docs' }" @click="activeTab = 'docs'">
                    <i class="ri-folder-2-line align-middle me-1"></i>เอกสารแนบ
                  </button>
                </li>
              </ul>
              <span class="badge fs-6" :class="loading ? 'bg-light text-muted' : status.cls">
                <i v-if="!loading" :class="status.icon" class="align-middle me-1"></i>{{ loading ? "กำลังโหลด" : status.label }}
              </span>
            </div>
          </div>
          <div class="card-body pt-3">
            <div class="app-detail-tab-scroll pe-2">
              <div v-if="activeTab === 'info'">
                <div class="row g-3">
                  <div class="col-12">
                    <div class="bg-light-subtle border rounded-3 p-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
                      <div>
                        <div class="text-muted small mb-1"><i class="ri-hashtag me-1"></i>เลขที่ใบสมัคร</div>
                        <h5 class="mb-0">{{ txt(app && app.application_no || config.applicationNo) }}</h5>
                      </div>
                      <div class="text-md-end">
                        <div class="text-muted small mb-1"><i class="ri-calendar-line me-1"></i>วันที่ยื่นใบสมัคร</div>
                        <div class="fw-medium">{{ toThaiDateTime(app && app.created_at) }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <h6 class="text-uppercase text-muted fw-semibold fs-12 mb-1"><i class="ri-user-3-line me-1 text-primary"></i>ข้อมูลส่วนบุคคล</h6>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-user-line me-1"></i>ชื่อผู้สมัคร</div>
                      <h6 class="mb-0">{{ displayName }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-profile-line me-1"></i>ประเภทใบสมัคร</div>
                      <h6 class="mb-0">บุคคลธรรมดา</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i :class="idCardIcon" class="me-1"></i>{{ idCardLabel }}</div>
                      <h6 class="mb-0">{{ txt(idCardValue) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-cake-2-line me-1"></i>วันเดือนปีเกิด</div>
                      <h6 class="mb-0">{{ toThaiDate(app && app.birth_date) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-flag-line me-1"></i>สัญชาติ</div>
                      <h6 class="mb-0">{{ txt(app && app.nationality) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-translate-2 me-1"></i>ชื่อภาษาอังกฤษ</div>
                      <h6 class="mb-0">{{ nameEn }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-history-line me-1"></i>ชื่อ-สกุลเดิม</div>
                      <h6 class="mb-0">{{ txt(app && app.old_name) }}</h6>
                    </div>
                  </div>
                  <div class="col-12 pt-1">
                    <h6 class="text-uppercase text-muted fw-semibold fs-12 mb-1"><i class="ri-quill-pen-line me-1 text-primary"></i>ข้อมูลเพิ่มเติม</h6>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-pen-nib-line me-1"></i>นามปากกา</div>
                      <h6 class="mb-0">{{ txt(app && app.pen_name) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-mic-line me-1"></i>บทบาทผู้สมัคร</div>
                      <div class="mt-1">
                        <span v-if="!roleBadges.length" class="text-muted">-</span>
                        <span v-for="role in roleBadges" :key="role" class="badge bg-primary-subtle text-primary me-1">{{ role }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 pt-1">
                    <h6 class="text-uppercase text-muted fw-semibold fs-12 mb-1"><i class="ri-contacts-book-2-line me-1 text-primary"></i>ข้อมูลติดต่อ</h6>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-phone-line me-1"></i>เบอร์โทรศัพท์</div>
                      <h6 class="mb-0">{{ txt(app && app.phone) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-mail-line me-1"></i>อีเมล</div>
                      <h6 class="mb-0">{{ txt(app && app.email) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-share-line me-1"></i>Social</div>
                      <h6 class="mb-0">
                        <i class="ri-chat-3-line me-1"></i>Line: {{ txt(app && app.line_id) }}<br>
                        <i class="ri-facebook-circle-line me-1"></i>Facebook: {{ txt(app && app.facebook) }}
                      </h6>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-home-4-line me-1"></i>ที่อยู่ตามทะเบียน</div>
                      <h6 class="mb-0">{{ addressText }}</h6>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-truck-line me-1"></i>ที่อยู่จัดส่งเอกสาร</div>
                      <h6 class="mb-0">{{ mailingAddressText }}</h6>
                    </div>
                  </div>
                  <div class="col-12 pt-1">
                    <h6 class="text-uppercase text-muted fw-semibold fs-12 mb-1"><i class="ri-bank-line me-1 text-primary"></i>ข้อมูลบัญชีธนาคาร</h6>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-building-line me-1"></i>ธนาคาร</div>
                      <h6 class="mb-0">{{ txt(app && app.bank_name) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-user-star-line me-1"></i>ชื่อบัญชี</div>
                      <h6 class="mb-0">{{ txt(app && app.bank_account_holder_name) }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-muted small mb-1"><i class="ri-numbers-line me-1"></i>เลขที่บัญชี</div>
                      <h6 class="mb-0">{{ txt(app && app.bank_account_number) }}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeTab === 'song'">
                <div class="row g-3">
                  <div class="col-lg-5">
                    <div class="border rounded-3 p-3 h-100 bg-light-subtle">
                      <div class="text-uppercase text-muted fw-semibold fs-12 mb-2"><i class="ri-music-2-line me-1 text-primary"></i>รายละเอียดเพลง</div>
                      <div class="border rounded-3 p-2 mb-2 bg-white">
                        <div class="small text-muted mb-1">ชื่อเพลง</div>
                        <div class="fw-semibold">{{ txt(app && app.song_title) }}</div>
                      </div>
                      <div class="border rounded-3 p-2 mb-2 bg-white">
                        <div class="small text-muted mb-1">ศิลปิน / อัลบั้ม</div>
                        <div><strong>ศิลปิน:</strong> {{ txt(app && app.song_artist) }}</div>
                        <div><strong>อัลบั้ม:</strong> {{ txt(app && app.song_album) }}</div>
                      </div>
                      <div class="border rounded-3 p-2 mb-2 bg-white">
                        <div class="small text-muted mb-1">เนื้อร้องขึ้นต้น</div>
                        <div>{{ txt(app && app.song_lyrics_opening) }}</div>
                      </div>
                      <div class="border rounded-3 p-2 mb-2 bg-white">
                        <div class="small text-muted mb-1">Publisher / URL เผยแพร่</div>
                        <div><strong>Publisher:</strong> {{ txt(app && app.publisher) }}</div>
                        <div class="text-break"><strong>URL:</strong> {{ txt(app && app.song_publish_url) }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="border rounded-3 p-3 h-100">
                      <div class="text-uppercase text-muted fw-semibold fs-12 mb-2"><i class="ri-group-line me-1 text-primary"></i>ผู้สร้างสรรค์ (ทำนอง / เนื้อร้อง / เรียบเรียง)</div>
                      <div v-for="block in creatorBlocks" :key="block.label" class="border rounded-3 p-2 mb-2">
                        <div class="small text-muted mb-1">{{ block.label }}</div>
                        <div class="fw-medium">
                          <span v-if="!block.names.length" class="text-muted">-</span>
                          <template v-else>{{ block.names.join(", ") }}</template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeTab === 'docs'">
                <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                  <div class="text-muted small"><i class="ri-attachment-2 me-1"></i>ไฟล์และเอกสารที่สร้างจากใบสมัคร</div>
                  <button type="button" class="btn btn-sm btn-primary" :disabled="!zipDownloadUrl" @click="onDownloadAllDocuments">
                    <i class="ri-download-2-line align-bottom me-1"></i>ดาวน์โหลดทั้งหมด (ZIP)
                  </button>
                </div>
                <div class="table-responsive">
                  <table class="table table-striped align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>ชื่อเอกสาร</th>
                        <th>สถานะ</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading || !app">
                        <td colspan="3" class="text-muted">กำลังโหลดข้อมูลเอกสาร...</td>
                      </tr>
                      <tr v-for="(row, idx) in documentRows" :key="idx">
                        <td>{{ row.name }}</td>
                        <td>
                          <span class="badge" :class="row.statusCls">{{ row.statusText }}</span>
                          <span v-if="row.extraBadge" class="badge bg-info-subtle text-info">{{ row.extraBadge }}</span>
                        </td>
                        <td class="text-center">
                          <div class="d-inline-block" style="width:120px;">
                            <button v-if="row.action === 'signature'" type="button" class="btn btn-sm btn-soft-primary w-100" @click="openSignatureModal">
                              <i class="ri-eye-line align-bottom me-1"></i>ดู
                            </button>
                            <a v-else-if="row.action === 'download'" class="btn btn-sm btn-soft-primary w-100" :href="row.href" :download="row.downloadName || (row.targetBlank ? undefined : '')" :target="row.targetBlank ? '_blank' : undefined" :rel="row.targetBlank ? 'noopener' : undefined">
                              <i class="ri-download-2-line align-bottom me-1"></i>Download
                            </a>
                            <div v-else-if="row.action === 'dropdown'" class="dropdown d-inline-block w-100">
                              <button class="btn btn-sm btn-soft-primary w-100 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="ri-download-2-line align-bottom me-1"></i>Download
                              </button>
                              <ul class="dropdown-menu dropdown-menu-end">
                                <li v-for="item in row.items" :key="item.label">
                                  <a class="dropdown-item" :href="item.href">{{ item.label }}</a>
                                </li>
                              </ul>
                            </div>
                            <span v-else class="text-muted">-</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4">
        <div class="card h-100 app-detail-review-card">
          <div class="card-header">
            <h4 class="card-title mb-0"><i class="ri-shield-check-line me-1 align-middle"></i>สรุปการตรวจสอบ</h4>
          </div>
          <div class="card-body">
            <div class="alert" :class="error ? 'alert-danger' : 'alert-info'" role="alert">
              {{ error || (loading ? "กำลังโหลดสถานะใบสมัคร" : status.msg) }}
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between px-0">
                <span><i class="ri-folder-check-line me-1 text-muted"></i>ความครบถ้วนเอกสาร</span>
                <span class="badge" :class="isDocComplete ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning'">{{ isDocComplete ? "ครบถ้วน" : "รอเอกสาร" }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0">
                <span><i class="ri-user-shared-line me-1 text-muted"></i>สถานะข้อมูลซ้ำ</span>
                <span class="badge bg-light text-muted">{{ isDuplicate ? "พบข้อมูลซ้ำ" : "ไม่พบ" }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between px-0">
                <span><i class="ri-user-star-line me-1 text-muted"></i>ผู้รับผิดชอบ</span>
                <span>{{ ownerName }}</span>
              </li>
            </ul>
            <div v-if="statusReasonText" class="border rounded-3 p-3 bg-light-subtle mt-3">
              <div class="text-muted small mb-1"><i class="ri-chat-1-line me-1"></i>เหตุผลสถานะ</div>
              <div class="fw-medium">{{ statusReasonText }}</div>
              <div class="small text-muted mt-1">{{ statusReasonMeta }}</div>
            </div>
            <div class="small text-muted mt-3">{{ consentMeta }}</div>
            <div v-if="hasRegistryTimeline" class="border rounded-3 p-3 bg-light-subtle mb-0 mt-3">
              <h6 class="text-uppercase text-muted fw-semibold fs-12 mb-2"><i class="ri-team-line me-1"></i>ทีมทะเบียน — บันทึกขั้นตอน</h6>
              <div v-if="hasRegistryViewedCol && registryViewedAt" class="mb-2">
                <span class="badge bg-success-subtle text-success"><i class="ri-eye-line align-middle me-1"></i>เปิดดูแล้ว</span>
                <div class="small text-muted mt-1">ล่าสุด {{ registryViewedMeta }}</div>
              </div>
              <div v-else-if="hasRegistryViewedCol" class="small text-muted mb-2">ยังไม่มีบันทึกการเปิดดู — ระบบจะบันทึกอัตโนมัติเมื่อเปิดหน้านี้</div>
              <div v-if="registryLogs.length === 0" class="small text-muted mb-2">ยังไม่มีขั้นตอนในไทม์ไลน์</div>
              <div v-else class="acitivity-timeline py-2 mb-3" style="max-height: 280px; overflow-y: auto;">
                <div v-for="(item, idx) in registryLogs" :key="item.id || idx" class="acitivity-item py-2 d-flex">
                  <div class="flex-shrink-0 avatar-xs acitivity-avatar">
                    <div class="avatar-title rounded-circle" :class="registryEventBadge(item.event_type)">
                      <i :class="registryEventIcon(item.event_type)"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="mb-1 fs-13">
                      {{ item.actor_name || "ทีมทะเบียน" }}
                      <span class="badge align-middle ms-1" :class="registryEventBadge(item.event_type)">{{ registryEventLabel(item.event_type) }}</span>
                    </h6>
                    <p class="text-muted mb-1" style="white-space: pre-wrap;">{{ item.message }}</p>
                    <small class="mb-0 text-muted">{{ toThaiDateTime(item.created_at) }}</small>
                  </div>
                </div>
              </div>
              <label class="form-label small mb-1" for="registry-review-note">เพิ่มขั้นตอน</label>
              <textarea id="registry-review-note" v-model="registryNote" class="form-control form-control-sm" rows="3" maxlength="4000" placeholder="เช่น ดาวน์โหลดเอกสาร และพิมพ์ตรวจสอบรอการอนุมัติ"></textarea>
              <button type="button" class="btn btn-sm btn-primary mt-2" :disabled="savingNote" @click="saveRegistryNote">
                <i class="ri-add-line align-bottom me-1"></i>{{ savingNote ? "กำลังบันทึก..." : "เพิ่มในไทม์ไลน์" }}
              </button>
              <div class="small text-danger mt-1">{{ registryNoteError }}</div>
            </div>
            <hr class="my-3">
            <div class="d-grid gap-2">
              <button v-if="!hideActionButtons" type="button" class="btn btn-success" @click="openApproveModal">
                <i class="ri-checkbox-circle-line align-bottom me-1"></i>อนุมัติใบสมัคร
              </button>
              <button v-if="!hideActionButtons" type="button" class="btn btn-danger" @click="openStatusReasonModal('rejected', 'ไม่อนุมัติใบสมัคร')">
                <i class="ri-close-circle-line align-bottom me-1"></i>ไม่อนุมัติ
              </button>
              <button v-if="!hideActionButtons" type="button" class="btn btn-warning" @click="openStatusReasonModal('incomplete', 'ตั้งสถานะข้อมูลไม่ครบ')">
                <i class="ri-file-warning-line align-bottom me-1"></i>ข้อมูลไม่ครบ
              </button>
              <button v-if="!hideActionButtons" type="button" class="btn btn-info" @click="openStatusReasonModal('duplicate', 'ตั้งสถานะใบสมัครซ้ำ')">
                <i class="ri-file-copy-2-line align-bottom me-1"></i>ใบสมัครซ้ำ
              </button>
              <a :href="listUrl" class="btn btn-light">
                <i class="ri-arrow-left-line align-bottom me-1"></i>กลับไปหน้ารายการใบสมัคร
              </a>
              <button v-if="canDelete" type="button" class="btn btn-outline-danger" :disabled="deleting" @click="onDeleteApplication">
                <i class="ri-delete-bin-line align-bottom me-1"></i>{{ deleting ? "กำลังลบ..." : "ลบข้อมูลใบสมัคร (ถาวร)" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="signatureModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ลายเซ็นผู้สมัคร</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center border rounded-3 p-3 bg-light-subtle overflow-auto" style="min-height: 200px; max-height: 70vh;">
              <img v-if="signatureData" :src="signatureData" alt="ลายเซ็นผู้สมัคร" class="d-inline-block" :style="{ width: signatureSize + '%', height: 'auto' }">
            </div>
            <div class="mt-3">
              <label class="form-label small mb-1">ขนาดการแสดงผล <span class="fw-medium">{{ signatureSize }}%</span></label>
              <input v-model.number="signatureSize" type="range" class="form-range" min="25" max="300" step="5">
              <div class="d-flex justify-content-between small text-muted">
                <span>เล็ก</span>
                <button type="button" class="btn btn-link btn-sm p-0" @click="resetSignatureSize">รีเซ็ต 100%</button>
                <span>ใหญ่</span>
              </div>
              <div class="alert alert-info py-2 px-3 small mb-0 mt-2">
                บันทึกขนาดนี้จะใช้กับลายเซ็นใน PDF ทุกฉบับของใบสมัครนี้ (ใบสมัครสมาชิก, PDPA, สัญญา ฯลฯ)
              </div>
              <div class="small text-danger mt-1">{{ signaturePdfError }}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" :disabled="savingSignatureSize" @click="saveSignaturePdfSize">{{ savingSignatureSize ? "กำลังบันทึก..." : "บันทึกขนาดสำหรับ PDF" }}</button>
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>

    <div ref="approveModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit="submitApproveForm">
            <div class="modal-header">
              <h5 class="modal-title">อนุมัติใบสมัครและสร้างสมาชิกหลัก</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="alert alert-info py-2 mb-3">ข้อมูลนี้จะใช้สร้างสมาชิกใหม่ในตารางสมาชิกหลัก</div>
              <div class="mb-2">
                <label class="form-label" for="approve-ipi-name-no">IPI Name No. *</label>
                <input id="approve-ipi-name-no" v-model="approve.ipi_name_no" type="text" class="form-control" inputmode="numeric" pattern="\d+" required>
              </div>
              <div class="mb-2">
                <label class="form-label" for="approve-ipi-base-no">IPI Base No. *</label>
                <input id="approve-ipi-base-no" v-model="approve.ipi_base_no" type="text" class="form-control" placeholder="I-000000000-0" required>
              </div>
              <div class="mb-2">
                <label class="form-label" for="approve-writer-type">ประเภทนักแต่ง *</label>
                <select id="approve-writer-type" v-model="approve.writer_type" class="form-select" required>
                  <option value="">— เลือก —</option>
                  <option value="General Member">General Member</option>
                  <option value="Associate Member">Associate Member</option>
                  <option value="Provisional Member">Provisional Member</option>
                </select>
              </div>
              <div class="mb-2">
                <label class="form-label" for="approve-rightsholder-type">ประเภทผู้ทรงสิทธิ *</label>
                <select id="approve-rightsholder-type" v-model="approve.rightsholder_type" class="form-select" required>
                  <option value="นักแต่งเพลง">นักแต่งเพลง</option>
                </select>
              </div>
              <div class="mb-2">
                <label class="form-label" for="approve-license-pdf">ไฟล์สัญญาอนุญาตสิทธิ (General + Digital) (PDF) *</label>
                <input id="approve-license-pdf" ref="licensePdf" type="file" class="form-control" accept="application/pdf,.pdf" required>
                <div class="form-text">รองรับเฉพาะไฟล์ PDF 1 ไฟล์ ขนาดไม่เกิน 15MB</div>
              </div>
              <div class="text-danger small mt-2">{{ approve.error }}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">ยกเลิก</button>
              <button type="submit" class="btn btn-success" :disabled="approving">{{ approving ? (approveProgress || "กำลังบันทึก...") : "อนุมัติและสร้างสมาชิก" }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div ref="statusReasonModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit="submitStatusReasonForm">
            <div class="modal-header">
              <h5 class="modal-title">{{ statusReasonTitle }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-2">
                <label class="form-label" for="status-reason-text">เหตุผล <span class="text-danger">*</span></label>
                <textarea id="status-reason-text" v-model="statusReason" class="form-control" rows="4" maxlength="2000" required placeholder="ระบุเหตุผลให้ผู้สมัครทราบ"></textarea>
                <div class="form-text">อย่างน้อย 5 ตัวอักษร — ระบบจะส่งอีเมลแจ้งผู้สมัครเมื่อไม่อนุมัติหรือข้อมูลไม่ครบ</div>
              </div>
              <div v-if="statusReasonError" class="text-danger small">{{ statusReasonError }}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">ยกเลิก</button>
              <button type="submit" class="btn btn-primary" :disabled="savingStatus">{{ savingStatus ? "กำลังบันทึก..." : "บันทึกสถานะ" }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.app-detail-tab-nav {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd #f3f6f9;
}
.app-detail-tab-nav::-webkit-scrollbar {
  height: 8px;
  display: block;
}
.app-detail-tab-nav::-webkit-scrollbar-track {
  background: #f3f6f9;
  border-radius: 8px;
}
.app-detail-tab-nav::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 8px;
}
.app-detail-tab-scroll {
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #6c757d #eef0f3;
}
.app-detail-tab-scroll::-webkit-scrollbar {
  width: 10px;
  display: block;
}
.app-detail-tab-scroll::-webkit-scrollbar-track {
  background: #eef0f3;
  border-radius: 8px;
}
.app-detail-tab-scroll::-webkit-scrollbar-thumb {
  background: #8b929a;
  border-radius: 8px;
}
.app-detail-tab-scroll::-webkit-scrollbar-thumb:hover {
  background: #6c757d;
}
@media (min-width: 1200px) {
  .app-detail-review-card {
    position: sticky;
    top: 90px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #6c757d #eef0f3;
  }
  .app-detail-review-card::-webkit-scrollbar {
    width: 8px;
    display: block;
  }
  .app-detail-review-card::-webkit-scrollbar-thumb {
    background: #adb5bd;
    border-radius: 8px;
  }
}
</style>
